// extracted by mini-css-extract-plugin
export default {"styledSelect":"styled-select_styledSelect__quqhk"};